// removed by extract-text-webpack-plugin
module.exports = {"bagLink":"_2jFRz","icon":"_3gA58","count":"usk7m"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ShoppingCartPopover/index.sass
// module id = 1507
// module chunks = 1